import "isomorphic-fetch";

import ApolloClient, { InMemoryCache } from "apollo-boost";
import { merge } from "lodash";

import defaultResolver from "../resolvers/default.resolver";
import editResolver from "../resolvers/editor.resolver";
import previewResolver from "../resolvers/preview.resolver";
import typeDefs from "./schema";

// const _ = require("lodash");
const client = new ApolloClient({
  cache: new InMemoryCache({
    dataIdFromObject: (obj: any) => {
      switch (obj.__typename) {
        case "ProductInfo":
        case "ProductItem":
          return obj.sno + "|" + obj.id;
          break;
        default:
          return obj.id;
      }
    },
  }),
  typeDefs,
  clientState: {
    ...merge(editResolver, defaultResolver, previewResolver),
  },

  uri:
    process.env.REACT_APP_GRAPHQL_SERVER ||
    "http://sketch.cakefactory.co.kr/api",
});

export { client };



// WEBPACK FOOTER //
// ./src/store/store.ts